import { render, staticRenderFns } from "./ChangePassword_dialog.vue?vue&type=template&id=7833c980&scoped=true&"
import script from "./ChangePassword_dialog.vue?vue&type=script&lang=js&"
export * from "./ChangePassword_dialog.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword_dialog.vue?vue&type=style&index=0&id=7833c980&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7833c980",
  null
  
)

export default component.exports